<script>
    import { spaLink } from "../lib/actions"

    if (typeof window === "undefined") {
        // ssr hint
        // @ts-ignore
        context.is404 = true
    }
</script>

<section class="tp-xxl bp-xxl">
    <div class="container bp-xl">
        <!-- Überschrift Element -->
        <h1>404</h1>
        <h3>Page not found - Seite nicht gefunden</h3>
    </div>
    <div class="container">
        <div class="grid">
            <div class="col-md-6 col-12">
                <p>
                    The page you are looking for might have been removed, had its name changed, or is temporarily
                    unavailable.
                </p>
                <div class="container tp-l">
                    <div class="button-wrap">
                        <a use:spaLink href="/" class="cta btn-primary">to home</a>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-12">
                <p>
                    Die gesuchte Seite wurde möglicherweise entfernt, ihr Name wurde geändert oder sie ist vorübergehend
                    nicht verfügbar.
                </p>
                <div class="container tp-l">
                    <div class="button-wrap">
                        <a use:spaLink href="/" class="cta btn-primary">zur Startseite</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
